import React from 'react';
import styles from './styles.module.css';

const ErrorPage = () => (
  <div className={styles.errorContainer}>
    <a href="https://native/exit">
      <button className={styles.button}>Back</button>
    </a>
    <h2>
      Sorry, there has been a technical error. Please try again later or contact support, if problem
      persists.
    </h2>
  </div>
);

export default ErrorPage;
